<template>
  <div>
    <div class="cloud-detial">
      <div class="cloud-more">
        <i class="fa fa-list"></i>
        <div class="cloud-menus">
          <slot name="menu"> </slot>
        </div>
      </div>
      <HeartVue @like="$emit('like')">
        <template v-slot:count>
          <i class="likes-text">{{ likeNum }}</i>
        </template>
      </HeartVue>
      <a v-if="showDetail" href="javascript:void(0);" @click="$emit('detail')">
        <span class="cloud-zoom fa fa fa-expand"></span>
      </a>
      <a
        v-if="showViewData"
        href="javascript:void(0);"
        @click="$emit('viewData')"
      >
        <span class="cloud-zoom fa fa-th-large"></span>
      </a>
    </div>
  </div>
</template>

<script>
import moreMenuVue from "./moreMenu.vue";
import HeartVue from "./Heart.vue";
export default {
  components: {
    moreMenuVue,
    HeartVue,
  },
  props: {
    likeNum: { Type: Number, default: 0, required: true },
    showDetail: { Type: Boolean, default: true },
    showViewData: { Type: Boolean, default: true },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Social/cloubTool.vue